import { en as sharedTranslationsEn } from "@shared/constants/translations-en.constants";
import { es as sharedTranslationsEs } from "@shared/constants/translations-es.constants";
import {
  DEFAULT_LOCALE,
  SUPPORTED_TRANSLATION_LOCALES,
} from "@shared/schemas/locale.schemas";
import { createI18n } from "@frontend/shared/infrastructure/i18n/create-i18n";
import { en as frontendTranslationsEn } from "@frontend/shared/infrastructure/i18n/translations/en";
import { es as frontendTranslationsEs } from "@frontend/shared/infrastructure/i18n/translations/es";
import { en } from "./translations/en";
import { es } from "./translations/es";

export const i18n = createI18n(SUPPORTED_TRANSLATION_LOCALES, DEFAULT_LOCALE, {
  en: { ...sharedTranslationsEn, ...frontendTranslationsEn, ...en },
  es: { ...sharedTranslationsEs, ...frontendTranslationsEs, ...es },
});
